export default __webpack_public_path__ + "static/mcgrath-sold-1ad44653b6dc27d9682fe432c424ab6b.png";